import React from 'react';
import classNames from 'classnames';
import { PeopleIcon } from '../../../Icons';
import ColumnTypes from '../../types/ColumnTypes';
import User from '../../components/User';
import textSort from '../utils/textSort';
var USER_COLUMN_TYPES = [ColumnTypes.USER, ColumnTypes.CREATED_BY, ColumnTypes.UPDATED_BY];
var USER_EDITABLE_COLUMN_TYPES = [ColumnTypes.USER];

var getUserId = function getUserId(_ref) {
  var column = _ref.column,
      record = _ref.record,
      field = _ref.field;
  var userId = null;

  switch (column.type) {
    case ColumnTypes.CREATED_BY:
      userId = record.createdBy;
      break;

    case ColumnTypes.UPDATED_BY:
      userId = record.updatedBy;
      break;

    case ColumnTypes.DATE:
      userId = field.data.userId || '';
      break;

    default:
      break;
  }

  return userId;
};

export default function UserPlugin() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$getUser = _ref2.getUser,
      getUser = _ref2$getUser === void 0 ? function (userId) {
    return null;
  } : _ref2$getUser;

  return [{
    getWidth: function getWidth(columnType, database, next) {
      if (USER_COLUMN_TYPES.includes(columnType)) {
        return 40;
      }

      return next();
    },
    renderColumnIcon: function renderColumnIcon(columnType, database, next) {
      if (USER_COLUMN_TYPES.includes(columnType)) {
        return React.createElement(PeopleIcon, null);
      }

      return next();
    },
    renderColumnType: function renderColumnType(columnType, database, next) {
      if (columnType === ColumnTypes.USER) {
        return 'People';
      }

      if (columnType === ColumnTypes.CREATED_BY) {
        return 'Created By';
      }

      if (columnType === ColumnTypes.UPDATED_BY) {
        return 'Updated By';
      }

      return next();
    },
    canEdit: function canEdit(columnType, database, next) {
      if (USER_COLUMN_TYPES.includes(columnType)) {
        return USER_EDITABLE_COLUMN_TYPES.includes(columnType);
      }

      return next();
    },
    canSort: function canSort(columnType, database, next) {
      if (!USER_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return true;
    },
    getSortOptions: function getSortOptions(columnType, database, next) {
      if (!USER_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return textSort.options;
    },
    getSortStrategies: function getSortStrategies(columnType, database, next) {
      if (!USER_COLUMN_TYPES.includes(columnType)) {
        return next();
      }

      return textSort.strategies(columnType, database, getUserId);
    },
    renderField: function renderField(_ref3, database, next) {
      var field = _ref3.field,
          column = _ref3.column,
          record = _ref3.record;

      if (!USER_COLUMN_TYPES.includes(column.type)) {
        return next();
      }

      var userId = getUserId({
        field: field,
        column: column,
        record: record
      });
      var user = getUser(userId);
      return React.createElement("div", {
        className: classNames('flexbox-grow height-full', 'padding-vertical-small padding-horizontal-normal', {
          pointer: USER_EDITABLE_COLUMN_TYPES.includes(column.type)
        })
      }, user ? React.createElement(User, {
        name: user.username
      }) : '');
    },
    serializeField: function serializeField(_ref4, database, next) {
      var column = _ref4.column,
          record = _ref4.record,
          field = _ref4.field;
      if (!USER_COLUMN_TYPES.includes(column.type)) return next();
      var userId = getUserId({
        column: column,
        record: record,
        field: field
      });

      var _ref5 = getUser(userId) || {},
          _ref5$username = _ref5.username,
          username = _ref5$username === void 0 ? 'anon' : _ref5$username;

      return "@".concat(username);
    }
  }];
}